import { GetUsersForLicenseRoutine } from '../redux-routines';
import type { ILicenseUsersResponse, ILicenseUsersState, IPayloadAction } from '../interfaces';

export const initialState: ILicenseUsersState = {
  isFetching: false,
  data: [],
  apiKeys: [],
  error: null,
};

export const licenseUsersReducer = (
  state: ILicenseUsersState = initialState,
  action: IPayloadAction,
): ILicenseUsersState => {
  switch (action.type) {
    case GetUsersForLicenseRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case GetUsersForLicenseRoutine.SUCCESS: {
      const { users, apiKeys } = action.payload as ILicenseUsersResponse;
      return {
        ...state,
        isFetching: false,
        data: users,
        apiKeys,
        error: null,
      };
    }
    case GetUsersForLicenseRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload as Error,
      };
    default:
      return state;
  }
};
